import { action } from 'mobx';
import { SessionStore } from './session.store';
import { AggregateFunction, AgtAnalyticsStore, IBmCount, SelectColumn } from './agt.analytics.store';

export class AgtAnalyticsKvAgenturMsStore extends AgtAnalyticsStore {
	constructor(session: SessionStore) {
		super(session, {
			tableName: 'kv_agentur_ms',
			defaultColumns: [
				{ column: 'group_id', aggregateFunction: AggregateFunction.NONE },
				{ column: 'bm', aggregateFunction: AggregateFunction.NONE },
			],
		});
		this.queryName = '?kvagenturms';
	}


	async countGroupBmData(group_id: string): Promise<IBmCount[]> {
		const selectColumns: SelectColumn[] = [
			{ column: 'bm', aggregateFunction: AggregateFunction.NONE, distinct: true, alias: 'bm', groupBy: true, },
			{ column: 'vtnr_id', aggregateFunction: AggregateFunction.COUNT, distinct: true, alias: 'count' },
		];
		const where = `group_id = '${group_id}'`;
		const results: IBmCount[] = await this.query(selectColumns, where);
		return results.sort((a, b) => b.bm - a.bm);
	}

}

export class AgtAnalyticsKvAgenturStore extends AgtAnalyticsStore {
	constructor(session: SessionStore) {
		super(session, {
			tableName: 'kv_agentur',
			defaultColumns: [
				{ column: 'bm', aggregateFunction: AggregateFunction.NONE },
			],
		});
		this.queryName = '?kvagenturms';
	}


	async countGroupData(group_id: string): Promise<IBmCount[]> {
		const selectColumns: SelectColumn[] = [
			{ column: 'vtnr_id', aggregateFunction: AggregateFunction.COUNT, distinct: true, alias: 'count' },
		];
		const where = `group_id = '${group_id}'`;
		const results: IBmCount[] = await this.query(selectColumns, where);
		return results.sort((a, b) => b.bm - a.bm);
	}

}